import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=b8d0b376"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=b8d0b376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports